// extracted by mini-css-extract-plugin
export var layoutContainer = "_4y-0";
export var layoutContainerNoRounding = "_4y-6";
export var layoutContainerOpen = "_4y-5";
export var layoutContainerResizing = "_4y-1";
export var mainContent = "_4y-2";
export var resizeDivider = "_4y-3";
export var slidePanel = "_4y-4";